import { createSelector } from 'reselect';

import { GlobalReducerState } from 'app/reducers';
import { makeSelectJvpField } from 'Containers/App/selectors';
import { BuilderGoSettings, JVPBootstrapPublicationInfo } from 'Utils/apiTypes';

import { MomentPageReducerState } from './reducer';

const selectMomentPageDomainAsJS = (state: GlobalReducerState): MomentPageReducerState => state.momentPage;

const makeSelectMomentPageField = <K extends keyof MomentPageReducerState>(field: K) =>
  createSelector(
    selectMomentPageDomainAsJS,
    (substate: MomentPageReducerState): MomentPageReducerState[K] => substate[field],
  );
const makeGetMomentSettings = (planYear: number) =>
  createSelector(
    makeSelectJvpField('active'),
    makeSelectJvpField('upcoming'),
    (
      active: JVPBootstrapPublicationInfo | null,
      upcoming: JVPBootstrapPublicationInfo | null,
    ): BuilderGoSettings | null =>
      active?.publication.plan_year === planYear
        ? active?.publication.go_settings
        : upcoming?.publication.plan_year === planYear
          ? upcoming?.publication.go_settings
          : null,
  );

export { selectMomentPageDomainAsJS, makeSelectMomentPageField, makeGetMomentSettings };
